import { useState } from 'react';

import { Box, Text, Icon, Flex, IconButton } from '@chakra-ui/react';

import { LikePisteIcon, DislikePisteIcon } from '@inspire/ui/icons';
import { useMyProfile } from 'lib/hooks';
import {
  GTM_CATEGORY_QUESTIONNAIRE,
  GTM_ACTION_ACCORD_CLASSEMENT,
  pushEvent,
} from 'lib/gtm';

const PisteFeedbackForAllPistes = ({}) => {
  const { myProfile, setAndRefetchMyProfile } = useMyProfile();

  const [likeSelected, setLikeSelected] = useState(
    myProfile.algoResultsRating === 2
  );
  const [dislikeSelected, setDislikeSelected] = useState(
    myProfile.algoResultsRating === -2
  );

  const noneSelected = !likeSelected && !dislikeSelected;

  return (
    <Box maxW="250px">
      <Text textAlign="center" mb={3}>
        Es-tu d'accord avec ce classement ?
      </Text>
      <Flex justifyContent={'space-evenly'}>
        <IconButton
          size="lg"
          aria-label="Oui"
          variant={noneSelected || likeSelected ? undefined : 'ghost'}
          icon={<Icon as={LikePisteIcon} boxSize={7} />}
          onClick={() => {
            setAndRefetchMyProfile({ algoResultsRating: 2 });
            setLikeSelected(true);
            setDislikeSelected(false);
            pushEvent(
              GTM_CATEGORY_QUESTIONNAIRE,
              GTM_ACTION_ACCORD_CLASSEMENT,
              'Accord'
            );
          }}
          color={likeSelected ? 'black' : 'blackAlpha.500'}
        />
        <IconButton
          size="lg"
          aria-label="Non"
          variant={noneSelected || dislikeSelected ? undefined : 'ghost'}
          icon={<Icon as={DislikePisteIcon} boxSize={7} />}
          onClick={() => {
            setAndRefetchMyProfile({ algoResultsRating: -2 });
            setDislikeSelected(true);
            setLikeSelected(false);
            pushEvent(
              GTM_CATEGORY_QUESTIONNAIRE,
              GTM_ACTION_ACCORD_CLASSEMENT,
              'Désaccord'
            );
          }}
          color={dislikeSelected ? 'black' : 'blackAlpha.500'}
        />
      </Flex>
    </Box>
  );
};

export default PisteFeedbackForAllPistes;
